import { useState } from "react";
import Zones from "./Zones/Zones";
import Employees from "./Employees/Employees";
interface DataTabProps {
  selectedDataTab: string | null;
  highlighting: boolean;
  dateRange: [Date | undefined, Date | undefined];
  setDateRange: (dateRange: [Date | undefined, Date | undefined]) => void;
  currentArea: string;
  currentSubArea: string | null;
  heatMapEnabled: boolean
  setHeatMapEnabled: Function
  selectedTab: string | null
  filterSmallValues: boolean
}

function DataTab({
  selectedDataTab,
  highlighting,
  dateRange,
  setDateRange,
  currentArea,
  currentSubArea,
  heatMapEnabled,
  setHeatMapEnabled,
  selectedTab,
  filterSmallValues
}: DataTabProps) {

  if (selectedTab === "zones") {

    return (
      <Zones highlighting={highlighting}
          dateRange={dateRange}
          currentArea={currentArea}
          currentSubArea={currentSubArea}
          filterSmallValues={ filterSmallValues}
          />
    )
  }

  if (selectedTab === "employees") {
    return (
      <Employees
        highlighting={highlighting}
        dateRange={dateRange}
        currentArea={currentArea}
        currentSubArea={currentSubArea}
        heatMapEnabled = {heatMapEnabled}
        setHeatMapEnabled = {setHeatMapEnabled}
        filterSmallValues ={filterSmallValues}
      />
    );
  }

  return null;
}

export default DataTab;
